import {Component, Input, OnInit} from '@angular/core';
import {DialogComponent} from "../../../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../../../ng2-bootstrap-modal/dialog.service";
import {AwsUploadService} from "../../../../../../services/aws-upload/aws-upload.service";
import {ManualMigrationDialogComponent} from "../../manual-migration-dialog.component";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../../../../store";
import * as fromStore from '../../../../../../../store';

@Component({
    selector: 'db-migration-progress-dialog',
    templateUrl: './migration-progress-dialog.component.html',
    styleUrls: ['./migration-progress-dialog.component.scss'],
    standalone: false
})
export class MigrationProgressDialogComponent extends DialogComponent<any, any> implements OnInit {
  @Input() openMigration = false;

  constructor(
    private _dialogService: DialogService,
    public awsUploadService: AwsUploadService,
    private _store: Store<DbStoreState>,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }

  retry() {
    if (!this.openMigration) {
      this.awsUploadService.retryUpload();
    } else {
      this._dialogService.removeDialog(this);
      this._dialogService.addDialog(ManualMigrationDialogComponent);
    }
  }

  openChat(): void {
    if (localStorage.getItem('dbChatZipFailMessageSent') === null) {
      window['Smooch']?.createConversation({
        messages: [
          {
            text: 'I need help with migration assistant',
            type: 'text',
            metadata: {
              ecommerce: true,
            }
          }
        ]
      }).then(() => {
        window['Smooch']?.open();
      });
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
      localStorage.setItem('dbChatZipFailMessageSent', '1');
    } else {
      window['Smooch']?.open();
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
    }
    this._dialogService.removeDialog(this);
  }

}
